export default __webpack_public_path__ + "static/dcut-226cef7117b5ed15f473776cb7b0b05c.jpg";